<template>
  <v-data-table
    :headers="headers"
    :items="units"
    sort-by="unitNumber"
    :search="search"
    class="elevation-1"
    v-model="selected"
    item-key="unitNumber"
    multi-sort
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Search"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-bottom-sheet v-model="sheet" scrollable>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])"
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              @click="clearSheet"
            >
              New Unit
            </v-btn>
          </template>

          <v-card>
            <v-tabs
              v-model="tab"
              centered
              fixed-tabs
              background-color="cyan"
              dark
              icons-and-text
            >
              <v-spacer></v-spacer>

              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab href="#tab-1">
                Unit
                <v-icon>mdi-briefcase-outline</v-icon>
              </v-tab>

              <v-tab href="#tab-2">
                Parts
                <v-icon>mdi-memory</v-icon>
              </v-tab>

              <!-- <v-tab
                v-if="editedItem.unitShow && !editedItem.parts && checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])"
                @click="editedItem.parts = true"
                href="#tab-3"
              >
                Add Parts
                <v-icon>mdi-plus</v-icon>
              </v-tab> -->

              <v-spacer></v-spacer>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editModeToggle(true)"
                v-if="
                  !editMode &&
                    !editModeDealer &&
                    checkRole([
                      'ROLE_LFADMIN',
                      'ROLE_LFTECH',
                      'ROLE_DEALERADMIN'
                    ])
                "
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editModeToggle(false)"
                v-if="editMode || editModeDealer"
              >
                <v-icon>mdi-pencil-off</v-icon>
              </v-btn>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="close()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-tabs>

            <v-card-text height="500">
              <v-tabs-items v-model="tab">
                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col cols="12" lg="8" offset-lg="2">
                            <v-row>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  v-model="editedItem.unitNumber"
                                  label="Unit Number"
                                  color="cyan"
                                  :rules="rules.required"
                                  required
                                  hint="Required"
                                  persistent-hint
                                  :readonly="!editMode"
                                ></v-text-field>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="6">
                                <v-textarea
                                  v-model="editedItem.unitNotes"
                                  rows="2"
                                  color="blue-grey"
                                  :readonly="!editMode"
                                  filled
                                  auto-grow
                                  background-color="orange lighten-4"
                                >
                                  <template v-slot:label>
                                    Unit Notes
                                  </template>
                                </v-textarea>
                              </v-col>
                            </v-row>

                            <v-expansion-panels>
                              <v-expansion-panel>
                                <v-expansion-panel-header
                                  color="cyan"
                                  class="white--text"
                                >
                                  Technical
                                  <template v-slot:actions>
                                    <v-icon color="white">
                                      $expand
                                    </v-icon>
                                  </template>
                                </v-expansion-panel-header>

                                <v-expansion-panel-content>
                                  <v-container>
                                    <v-row dense>
                                      <v-col cols="12" sm="6">
                                        <v-text-field
                                          v-model="
                                            editedItem.manufactureDateShow
                                          "
                                          label="Manufacture Date"
                                          color="cyan"
                                          readonly
                                        >
                                          <template v-slot:append-outer>
                                            <v-tooltip top>
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  icon
                                                  @click="
                                                    dialogManufactureUnit = true
                                                  "
                                                  :disabled="
                                                    editedItem.manufactureDate !=
                                                      null
                                                  "
                                                  v-bind="attrs"
                                                  v-on="on"
                                                >
                                                  <v-icon
                                                    >mdi-briefcase-check</v-icon
                                                  >
                                                </v-btn>
                                              </template>
                                              <span>Mark as Manufactured</span>
                                            </v-tooltip>
                                          </template>
                                        </v-text-field>
                                      </v-col>
                                    </v-row>

                                    <v-row dense>
                                      <v-col cols="12" sm="6">
                                        <v-text-field
                                          v-model="
                                            editedItem.commissionDateShow
                                          "
                                          label="Commission Date"
                                          color="cyan"
                                          readonly
                                        ></v-text-field>
                                      </v-col>

                                      <v-col cols="12" sm="6">
                                        <v-text-field
                                          v-model="
                                            editedItem.decommissionDateShow
                                          "
                                          label="Decommission Date"
                                          color="cyan"
                                          readonly
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                      </v-container>

                      <v-container>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn plain @click="close">
                            Cancel
                          </v-btn>
                          <v-btn color="cyan" dark @click="save">
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>

                <v-tab-item value="tab-2">
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col cols="11">
                            <v-row>
                              <v-col
                                cols="12"
                                class="pb-0"
                                v-for="(part, index) in editedItem.parts"
                                :key="part.partID"
                              >
                                <v-card>
                                  <v-toolbar dense dark color="cyan">
                                    <v-toolbar-title>
                                      <v-btn
                                        text
                                        dark
                                        depressed
                                        @click="showPart(part.partID)"
                                      >
                                        {{
                                          part.partName
                                            ? part.partName
                                            : part.partString
                                        }}
                                      </v-btn>
                                    </v-toolbar-title>

                                    <v-spacer></v-spacer>

                                    <v-slide-x-transition>
                                      <div
                                        v-show="
                                          partShow == part.partID &&
                                            partEdit != part.partID
                                        "
                                      >
                                        <v-tooltip bottom>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              v-show="
                                                partShow == part.partID &&
                                                  partEdit != part.partID
                                              "
                                              fab
                                              icon
                                              small
                                              @click="deletePartDialog(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-trash-can
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Delete</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-transition>

                                    <v-slide-x-transition>
                                      <div
                                        v-show="
                                          partShow == part.partID &&
                                            partEdit != part.partID
                                        "
                                      >
                                        <v-tooltip bottom>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              v-show="
                                                partShow == part.partID &&
                                                  partEdit != part.partID
                                              "
                                              fab
                                              icon
                                              small
                                              @click="editPart(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-pencil
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Edit</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-transition>

                                    <v-slide-x-reverse-transition>
                                      <div
                                        v-show="
                                          partShow == part.partID &&
                                            partEdit == part.partID
                                        "
                                      >
                                        <v-tooltip bottom>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              fab
                                              icon
                                              small
                                              @click="undoPart(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-undo-variant
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Undo</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-reverse-transition>

                                    <v-slide-x-reverse-transition>
                                      <div
                                        v-show="
                                          partShow == part.partID &&
                                            partEdit == part.partID
                                        "
                                      >
                                        <v-tooltip bottom>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              v-show="
                                                partShow == part.partID &&
                                                  partEdit == part.partID
                                              "
                                              fab
                                              icon
                                              small
                                              @click="savePart(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-check
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Save</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-reverse-transition>

                                    <v-btn
                                      fab
                                      icon
                                      small
                                      @click="showPart(part.partID)"
                                    >
                                      <v-icon v-if="partShow != part.partID"
                                        >mdi-chevron-down</v-icon
                                      >
                                      <v-icon v-else>mdi-chevron-up</v-icon>
                                    </v-btn>
                                  </v-toolbar>

                                  <v-expand-transition>
                                    <div v-show="partShow == part.partID">
                                      <v-card-text>
                                        <v-container>
                                          <v-row dense>
                                            <v-col cols="12" sm="6">
                                              <v-text-field
                                                v-model="part.partName"
                                                label="Name"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6">
                                              <v-text-field
                                                v-model="part.partString"
                                                label="String"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col cols="12" sm="4">
                                              <v-text-field
                                                v-model="part.partMake"
                                                label="Make"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="4">
                                              <v-text-field
                                                v-model="part.partModel"
                                                label="Model"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="4">
                                              <v-text-field
                                                v-model="part.partSN"
                                                label="SN"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col cols="12" sm="6">
                                              <v-text-field
                                                v-model="part.curveM"
                                                label="Curve M"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6">
                                              <v-text-field
                                                v-model="part.curveB"
                                                label="Curve B"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col cols="12" sm="6">
                                              <v-textarea
                                                v-model="part.partNotes"
                                                rows="2"
                                                color="blue-grey"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                filled
                                                auto-grow
                                                background-color="orange lighten-4"
                                                dense
                                              >
                                                <template v-slot:label>
                                                  Part Notes
                                                </template>
                                              </v-textarea>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col cols="12">
                                              <v-expansion-panels>
                                                <v-expansion-panel>
                                                  <v-expansion-panel-header
                                                    color="cyan"
                                                    class="white--text"
                                                  >
                                                    Technical
                                                    <template v-slot:actions>
                                                      <v-icon color="white">
                                                        $expand
                                                      </v-icon>
                                                    </template>
                                                  </v-expansion-panel-header>

                                                  <v-expansion-panel-content>
                                                    <v-container>
                                                      <v-row dense>
                                                        <v-col cols="12" sm="6">
                                                          <v-text-field
                                                            v-model="
                                                              part.installDateShow
                                                            "
                                                            label="Install Date"
                                                            color="cyan"
                                                            disabled
                                                          ></v-text-field>
                                                        </v-col>
                                                      </v-row>

                                                      <v-row dense>
                                                        <v-col cols="12" sm="6">
                                                          <v-text-field
                                                            v-model="
                                                              part.commissionDateShow
                                                            "
                                                            label="Commission Date"
                                                            color="cyan"
                                                            disabled
                                                          ></v-text-field>
                                                        </v-col>

                                                        <v-col cols="12" sm="6">
                                                          <v-text-field
                                                            v-model="
                                                              part.decommissionDateShow
                                                            "
                                                            label="Decommission Date"
                                                            color="cyan"
                                                            disabled
                                                          ></v-text-field>
                                                        </v-col>
                                                      </v-row>
                                                    </v-container>
                                                  </v-expansion-panel-content>
                                                </v-expansion-panel>
                                              </v-expansion-panels>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card-text>
                                    </div>
                                  </v-expand-transition>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col
                            cols="1"
                            :offset="
                              Object.keys(editedItem.parts).length > 0 ? 0 : 10
                            "
                          >
                            <v-row>
                              <v-col cols="12">
                                <v-btn
                                  icon
                                  elevation="2"
                                  fab
                                  @click="addPartDialog"
                                >
                                  <v-icon>
                                    mdi-plus
                                  </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Are you sure you want to delete this LOL?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDelete">
                Cancel
              </v-btn>
              <v-btn color="error" dark @click="deleteItemConfirm">
                Delete
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDeletePart" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Are you sure you want to delete this part?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="deletePartDialogClose">
                Cancel
              </v-btn>
              <v-btn color="error" dark @click="destroyPart">
                Delete
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAddPart" max-width="800px">
          <v-card>
            <v-card-title class="headline">
              Add Part
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="partCreate.partName"
                      label="Part Name"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="partCreate.partString"
                      label="Part String"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="partCreate.partMake"
                      label="Make"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="partCreate.partModel"
                      label="Model"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="partCreate.partSN"
                      label="SN"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      v-model="partCreate.partNotes"
                      rows="2"
                      color="cyan"
                    >
                      <template v-slot:label>
                        <div>Part Notes <small>(internal)</small></div>
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="addPartDialogClose">Cancel</v-btn>
              <v-btn color="cyan" dark @click="addPart">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCalibration" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Perform Calibration

              <v-spacer></v-spacer>

              <v-btn
                icon
                v-if="calibrationStep != 'initial'"
                @click="calibrationStep = 'initial'"
              >
                <v-icon>mdi-restart</v-icon>
              </v-btn>

              <v-btn icon @click="dialogCalibration = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'initial'">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          height="100"
                          color="cyan"
                          @click="calibrationStep = 'keep'"
                        >
                          <v-icon left>
                            mdi-briefcase-check-outline
                          </v-icon>
                          Keep Unit
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          color="cyan"
                          height="100"
                          @click="calibrationStep = 'change'"
                        >
                          <v-icon left>
                            mdi-briefcase-edit-outline
                          </v-icon>
                          Change Unit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'keep'">
                    <v-row>
                      <v-col cols="12">
                        Are you ready to complete this calibration?<br />
                        (Assigned unit will stay the same)
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="calibrationData.calibrationNotes"
                          rows="2"
                          color="blue-grey"
                          filled
                          auto-grow
                          background-color="orange lighten-4"
                        >
                          <template v-slot:label>
                            Calibration Notes
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'change'">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          height="100"
                          color="cyan"
                          @click="calibrationStep = 'changeUnassigned'"
                        >
                          <v-icon left>
                            mdi-briefcase-search-outline
                          </v-icon>
                          Unassigned Unit
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          color="cyan"
                          height="100"
                          @click="calibrationStep = 'changeNew'"
                        >
                          <v-icon left>
                            mdi-briefcase-plus-outline
                          </v-icon>
                          New Unit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'changeUnassigned'">
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="unitCalibration"
                          label="Unit"
                          :items="units"
                          item-text="unitNumber"
                          item-value="unitID"
                          color="cyan"
                          item-color="cyan"
                          return-object
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'changeNew'">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="unitCalibration.unitNumber"
                          label="Unit Number"
                          color="cyan"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="unitCalibration.unitNotes"
                          rows="2"
                          color="blue-grey"
                          filled
                          auto-grow
                          background-color="orange lighten-4"
                        >
                          <template v-slot:label>
                            Unit Notes
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div
                    v-show="
                      calibrationStep == 'changeUnassignedConfirm' ||
                        calibrationStep == 'changeNewConfirm'
                    "
                  >
                    <v-row>
                      <v-col cols="12">
                        Are you ready to complete this calibration?
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6" v-if="editedItem.unitShow">
                        <v-row>
                          <v-col cols="12">
                            Previous Unit:
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <v-card class="px-4">
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="editedItem.unit.unitNumber"
                                    label="Unit Number"
                                    class="pt-4"
                                    color="cyan"
                                    readonly
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12">
                                  <v-textarea
                                    v-model="editedItem.unit.unitNotes"
                                    rows="2"
                                    color="blue-grey"
                                    filled
                                    auto-grow
                                    background-color="orange lighten-4"
                                    readonly
                                    dense
                                  >
                                    <template v-slot:label>
                                      Unit Notes
                                    </template>
                                  </v-textarea>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="6">
                        <v-row>
                          <v-col cols="12">
                            New Unit:
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <v-card class="px-4">
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="unitCalibration.unitNumber"
                                    label="Unit Number"
                                    class="pt-4"
                                    color="cyan"
                                    readonly
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12">
                                  <v-textarea
                                    v-model="unitCalibration.unitNotes"
                                    rows="2"
                                    color="blue-grey"
                                    filled
                                    auto-grow
                                    background-color="orange lighten-4"
                                    readonly
                                    dense
                                  >
                                    <template v-slot:label>
                                      Unit Notes
                                    </template>
                                  </v-textarea>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="calibrationData.calibrationNotes"
                          rows="2"
                          color="blue-grey"
                          filled
                          auto-grow
                          background-color="orange lighten-4"
                        >
                          <template v-slot:label>
                            Calibration Notes
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                v-if="calibrationStep == 'changeUnassigned'"
                class="mb-2"
                color="cyan"
                dark
                @click="calibrationStep = 'changeUnassignedConfirm'"
              >
                Continue
              </v-btn>

              <v-btn
                v-if="calibrationStep == 'changeNew'"
                class="mb-2"
                color="cyan"
                dark
                @click="calibrationStep = 'changeNewConfirm'"
              >
                Continue
              </v-btn>

              <v-btn
                v-if="
                  calibrationStep == 'keep' ||
                    calibrationStep == 'changeUnassignedConfirm' ||
                    calibrationStep == 'changeNewConfirm'
                "
                class="mb-2"
                color="cyan"
                dark
                @click="performCalibration()"
              >
                Finish
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogManufactureUnit" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Are you sure you want to mark this Unit as manufactured?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogManufactureUnit = false">
                Cancel
              </v-btn>
              <v-btn color="cyan" dark @click="manufactureUnit()">
                Manufacture
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-divider></v-divider>
    </template>

    <template v-slot:item.unitNumber="props">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="subtitle-1"
            style="border-bottom: 1px dashed #111; cursor: pointer;"
            @click="editItem(props.item)"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.item.unitNumber }}
          </span>
        </template>
        <span>View Unit</span>
      </v-tooltip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="black"
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>Actions</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item @click="editItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon>mdi-magnify</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>View</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import LolService from '../../../services/lol.service'
import UnitService from '../../../services/unit.service'
import PartService from '../../../services/part.service'
import CurveService from '../../../services/curve.service'
import CustomerService from '../../../services/customer.service'
import LocationService from '../../../services/location.service'
import CalibrationService from '../../../services/calibration.service'

export default {
  data: () => ({
    search: '',
    message: '',
    selected: [],
    loading: false,
    sheet: false,
    tab: null,
    dialogDelete: false,
    dialogAddPart: false,
    dialogDeletePart: false,
    dialogCalibration: false,
    dialogManufactureUnit: false,
    headers: [
      { text: 'Unit Number', align: 'start', value: 'unitNumber' },
      { text: 'LOL Number', align: 'start', value: 'lol.lolNumber' },
      { text: 'Dealer', align: 'start', value: 'customer.customerName' },
      { text: 'Manufacture Date', value: 'manufactureDateShow' },
      { text: 'Commission Date', value: 'commissionDateShow' },
      { text: 'Decommission Date', value: 'decommissionDateShow' },
      { text: 'Actions', value: 'actions', align: 'center', sortable: false }
    ],
    lols: [],
    dealers: [],
    locations: [],
    units: [],
    unitAddStep: '',
    partShow: 0,
    partEdit: 0,
    unitCreate: {},
    unitUpdate: {},
    unitCalibration: {},
    calibrationData: {},
    calibrationStep: 'initial',
    partCreate: {},
    partBeforeEdit: {},
    partUpdate: {},
    partDelete: null,
    editedIndex: -1,
    editedItem: {
      unitNumber: '',
      unitNotes: '',
      manufactureDate: null,
      commissionDate: null,
      decommissionDate: null,
      lol: {},
      parts: []
    },
    defaultItem: {
      unitNumber: '',
      unitNotes: null,
      manufactureDate: null,
      commissionDate: null,
      decommissionDate: null,
      lol: {},
      parts: []
    },
    editMode: false,
    editModeDealer: false,
    rules: {
      required: [(value) => value.length != 0 || 'Required']
    }
  }),

  computed: {
    currentUser() {
      return this.$store.state.auth.user
    }
  },

  watch: {},

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      this.checkAuth()
      this.retrieveUnits()
      // this.retrieveDealers()
      // this.retrieveLocations()
      // this.retrieveUnassignedUnits()
    },

    checkAuth() {
      if (
        !this.$route.meta.authorize.includes(this.currentUser.roles.toString())
      ) {
        this.$router.push('/dashboard')
      }
    },

    checkRole(role) {
      if (Array.isArray(role)) {
        var i
        for (i = 0; i < role.length; i++) {
          if (this.currentUser.roles.includes(role[i])) {
            return true
          }
          if (role[i] == 'lf') {
            if (
              this.currentUser.roles.includes('ROLE_LFADMIN') ||
              this.currentUser.roles.includes('ROLE_LFTECH') ||
              this.currentUser.roles.includes('ROLE_LFBILLING')
            ) {
              return true
            }
          }
          if (role[i] == 'dealer') {
            if (
              this.currentUser.roles.includes('ROLE_DEALERADMIN') ||
              this.currentUser.roles.includes('ROLE_DEALERTECH')
            ) {
              return true
            }
          }
        }
        return false
      }

      if (role == 'lf') {
        if (
          this.currentUser.roles.includes('ROLE_LFADMIN') ||
          this.currentUser.roles.includes('ROLE_LFTECH') ||
          this.currentUser.roles.includes('ROLE_LFBILLING')
        ) {
          return true
        }
      }

      if (role == 'dealer') {
        if (
          this.currentUser.roles.includes('ROLE_DEALERADMIN') ||
          this.currentUser.roles.includes('ROLE_DEALERTECH')
        ) {
          return true
        }
      }

      if (this.currentUser.roles.includes(role)) {
        return true
      } else {
        return false
      }
    },

    retrieveDealers() {
      CustomerService.getDealers()
        .then((response) => {
          this.dealers = response.data || []
        })
        .catch((e) => {
          console.log(e)
        })
    },

    async retrieveUnits() {
      this.loading = true
      await UnitService.getAll()
        .then(async (response) => {
          this.units = response.data || []

          for (const unit of this.units) {
            if (unit.manufactureDate != null) {
              unit.manufactureDateShow = unit.manufactureDate
                .substring(0, 10)
                .replaceAll('-', '/')
            }
            if (unit.commissionDate != null) {
              unit.commissionDateShow = unit.commissionDate
                .substring(0, 10)
                .replaceAll('-', '/')
            }
            if (unit.decommissionDate != null) {
              unit.decommissionDateShow = unit.decommissionDate
                .substring(0, 10)
                .replaceAll('-', '/')
            }

            await LolService.get(unit.lolID).then((response) => {
              unit.lol = response.data

              return new Promise((resolve) => {
                resolve('Done')
              })
            })

            await CustomerService.get(unit.lol.customerID).then((response) => {
              unit.customer = response.data

              return new Promise((resolve) => {
                resolve('Done')
              })
            })

            await PartService.getUnitParts(unit.unitID).then((response) => {
              unit.parts = response.data

              return new Promise((resolve) => {
                resolve('Done')
              })
            })
          }

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
        })
      this.loading = false
    },

    retrieveUnassignedUnits() {
      UnitService.getUnassigned()
        .then((response) => {
          this.units = response.data || []
        })
        .catch((e) => {
          console.log(e)
        })
    },

    createUnit() {
      this.unitCreate = this.editedItem
      UnitService.create(this.unitCreate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The unit was created successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    updateUnit() {
      this.unitUpdate = this.editedItem
      UnitService.update(this.unitUpdate.unitID, this.unitUpdate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The unit was updated successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    createPart() {
      PartService.create(this.partCreate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The part was added successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    updatePart() {
      PartService.update(this.partUpdate.partID, this.partUpdate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The part was updated successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    deletePart() {
      PartService.delete(this.partDelete.partID)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The part was deleted successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    createCurve() {
      CurveService.create(this.partUpdate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The curve was added successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    updateCurve() {
      CurveService.update(this.partUpdate.curveID, this.partUpdate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The curve was updated successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    addPartDialog() {
      this.partCreate = {}
      this.partCreate.unitID = this.editedItem.unitID
      this.dialogAddPart = true
    },

    addPartDialogClose() {
      this.partCreate = {}
      this.dialogAddPart = false
    },

    addPart() {
      if (this.partCreate.partString) {
        this.editedItem.parts.push(this.partCreate)
        this.createPart()
      } else {
        this.snackbar('Missing part info!', 'error', '3000')
      }
      this.dialogAddPart = false
    },

    showPart(partID) {
      if (this.partShow == partID) {
        this.partShow = 0
        this.partEdit = 0
      } else {
        this.partShow = partID
        this.partEdit = 0
      }
    },

    editPart(index) {
      var partID = this.editedItem.parts[index].partID

      if (this.partEdit == partID) {
        this.partEdit = 0
        this.partBeforeEdit = {}
      } else {
        this.partEdit = partID
        this.partBeforeEdit = this.editedItem.parts[index]
        this.partBeforeEdit = Object.assign({}, this.editedItem.parts[index])
      }
    },

    savePart(index) {
      this.partUpdate = {}
      this.partUpdate = this.editedItem.parts[index]
      this.updatePart()
      if (
        this.partUpdate.curveM != this.partBeforeEdit.curveM ||
        this.partUpdate.curveB != this.partBeforeEdit.curveB
      ) {
        this.createCurve()
      }
      this.partEdit = 0
    },

    undoPart(index) {
      this.editedItem.parts.splice(index, 1, this.partBeforeEdit)
      this.partEdit = 0
    },

    deletePartDialog(index) {
      this.partDelete = this.editedItem.parts[index]
      this.partDelete.index = index
      this.dialogDeletePart = true
    },

    deletePartDialogClose() {
      this.partDelete = null
      this.dialogDeletePart = false
    },

    destroyPart() {
      this.editedItem.parts.splice(this.partDelete.index, 1)
      this.deletePart()
      this.dialogDeletePart = false
    },

    clearSheet() {
      this.editMode = true
      this.editedItem.unitNumber = ''
      this.editedItem.unitNotes = null
      this.editedItem.manufactureDate = null
      this.editedItem.commissionDate = null
      this.editedItem.decommissionDate = null
      this.editedItem.lol = {}
      this.editedItem.parts = []
      this.editedIndex = -1
      this.tab = 1
    },

    async editItem(item) {
      this.editMode = false
      this.editedIndex = this.units.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.sheet = true
      this.tab = 'tab-1'
    },

    deleteItem(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      this.lols.splice(this.editedIndex, 1)
      this.deleteLol()
      this.closeDelete()
    },

    close() {
      this.sheet = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save() {
      if (this.editedItem.unitNumber) {
        if (this.editedIndex > -1) {
          Object.assign(this.units[this.editedIndex], this.editedItem)
          this.updateUnit()
        } else {
          this.units.push(this.editedItem)
          this.createUnit()
        }
      } else {
        this.snackbar('Missing unit info!', 'error', '3000')
      }
      // this.close()
    },

    editModeToggle(toggle) {
      if (toggle) {
        if (this.checkRole('lf')) {
          this.editMode = true
        } else {
          this.editModeDealer = true
        }
      } else {
        this.editMode = false
        this.editModeDealer = false
      }
    },

    openCalibrationDialog() {
      this.dialogCalibration = true
    },

    async performCalibration() {
      this.unitCalibration.lolID = this.editedItem.lolID
      this.calibrationData.lolID = this.editedItem.lolID
      this.calibrationData.beforeUnitID = this.editedItem.unit.unitID
      this.calibrationData.calibrationDate = new Date().getTime()
      let d = new Date()
      let n = d.toJSON()
      let ymd = n.substring(0, 10).replace(/-/g, '')
      let hmsm = n
        .substring(11, 23)
        .replace(/:/g, '')
        .replace('.', '')
      this.calibrationData.calibrationNumber = ymd + hmsm

      if (this.calibrationStep.includes('Unassigned')) {
        this.calibrationData.afterUnitID = this.unitCalibration.unitID

        UnitService.update(this.unitCalibration.unitID, this.unitCalibration)
          .then((response) => {
            this.snackbar(
              'Success! The unit was assigned successfully',
              'success'
            )
          })
          .catch((e) => {
            console.log(e)
          })
      } else if (this.calibrationStep.includes('New')) {
        await UnitService.create(this.unitCalibration)
          .then((response) => {
            this.snackbar(
              'Success! The unit was created successfully',
              'success'
            )
            this.calibrationData.afterUnitID = response.data.unitID

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
          })
      } else {
        this.calibrationData.afterUnitID = this.editedItem.unit.unitID
      }

      CalibrationService.create(this.calibrationData)
        .then((response) => {
          this.snackbar(
            'Success! The calibration was performed successfully',
            'success'
          )
          this.sheet = false
        })
        .catch((e) => {
          console.log(e)
        })

      this.calibrationStep = 'initial'
      this.dialogCalibration = false
    },

    manufactureUnit() {
      if (!this.editedItem.unit.manufactureDate) {
        var manufactureDate = new Date().getTime()
        var updateUnit = { manufactureDate: manufactureDate }
        UnitService.update(this.editedItem.unit.unitID, updateUnit)
          .then((response) => {
            this.snackbar(
              'Success! Unit successfully marked as manufactured',
              'success'
            )
            this.dialogManufactureUnit = false
            this.sheet = false
          })
          .catch((e) => {
            console.log(e)
            this.snackbar(
              'Error! There was an error marking Unit as manufactured',
              'error',
              0
            )
          })
      }
    },

    snackbar(message, color, timeout) {
      window._LOL2P.$emit('SHOW_SNACKBAR', {
        text: message,
        color: color,
        timeout: timeout
      })
    }
  }
}
</script>
